import { FormInputProps } from '@form/props';
import Checkbox from '@ui/Table/Checkbox';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface Props extends FormInputProps {}

export const PermissionInput: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ name, label }) => {
    const { control } = useFormContext();
    const {
        field: { value, onChange }
    } = useController({ name, control });

    const handleCheckboxChange = (mode: boolean) => {
        if (value === null || value === !mode) {
            onChange(mode);
        } else {
            onChange(null);
        }
    };

    return (
        <>
            <div className="tw-justify-self-center">
                <Checkbox
                    aria-labelledby={name}
                    isSelected={value === true}
                    onChange={() => handleCheckboxChange(true)}
                />
            </div>
            <div className="tw-justify-self-center">
                <Checkbox
                    aria-labelledby={name}
                    isSelected={value === false}
                    onChange={() => handleCheckboxChange(false)}
                />
            </div>
            <label id={name}>{label}</label>
        </>
    );
};
